// extracted by mini-css-extract-plugin
export var btn = "main-module--btn--969e8";
export var title = "main-module--title--1d8c0";